import { render } from "./EditPersonalObjectiveForm.vue?vue&type=template&id=936972fc&scoped=true"
import script from "./EditPersonalObjectiveForm.vue?vue&type=script&lang=js"
export * from "./EditPersonalObjectiveForm.vue?vue&type=script&lang=js"

import "./EditPersonalObjectiveForm.vue?vue&type=style&index=0&id=936972fc&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-936972fc"]])

export default __exports__